import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgSelectModule} from '@ng-select/ng-select';
import {SharedModule} from '@shared/shared.module';
import {MachineGroupComponent} from '@components/administration/machine-group/machine-group.component';
import {MachineGroupActionComponent} from '@components/administration/machine-group/machine-group-action/machine-group-action.component';
import {MachineGroupConfigurationComponent} from '@components/administration/machine-group/machine-group-configuration/machine-group-configuration.component';
import {MachineGroupUsersComponent} from '@components/administration/machine-group/machine-group-configuration/machine-group-users/machine-group-users.component';
import {MachineGroupRoutingModule} from '@components/administration/machine-group/machine-group-routing.module';
import {MachineGroupEditComponent} from '@components/administration/machine-group/machine-group-edit/machine-group-edit.component';
import {MachineGroupMachinesComponent} from '@components/administration/machine-group/machine-group-configuration/machine-group-machines/machine-group-machines.component';
import {MachineGroupGroupsComponent} from '@components/administration/machine-group/machine-group-configuration/machine-group-groups/machine-group-groups.component';
import { AdminMachineGroupTriggerActionComponent } from './machine-group-configuration/admin-machine-group-trigger-action/admin-machine-group-trigger-action.component';
import { AdminMachineGroupTriggerConfigurationComponent } from './machine-group-configuration/admin-machine-group-trigger-configuration/admin-machine-group-trigger-configuration.component';
import { TriggerQueryActionComponent } from './machine-group-configuration/admin-machine-group-trigger-action/triger-query-action/trigger-query-action.component';
import { MachineGroupTriggerConfigurationEditComponent } from './machine-group-configuration/admin-machine-group-trigger-configuration/machine-group-trigger-configuration-edit/machine-group-trigger-configuration-edit.component';
import { MachineGroupTriggerConfigurationActionComponent } from './machine-group-configuration/admin-machine-group-trigger-configuration/machine-group-trigger-configuration-action/machine-group-trigger-configuration-action.component';
import {MachineModule} from '@components/administration/machine/machine.module';


@NgModule({
  declarations: [
    MachineGroupComponent,
    MachineGroupActionComponent,
    MachineGroupEditComponent,
    MachineGroupConfigurationComponent,
    MachineGroupMachinesComponent,
    MachineGroupUsersComponent,
    MachineGroupGroupsComponent,
    AdminMachineGroupTriggerActionComponent,
    AdminMachineGroupTriggerConfigurationComponent,
    TriggerQueryActionComponent,
    MachineGroupTriggerConfigurationEditComponent,
    MachineGroupTriggerConfigurationActionComponent
  ],
    imports: [
      CommonModule,
      TranslateModule,
      NgbModule,
      FormsModule,
      RouterModule,
      NgSelectModule,
      ReactiveFormsModule,
      SharedModule,
      MachineGroupRoutingModule,
      MachineModule
    ],
  exports: [
    MachineGroupComponent
  ]
})
export class MachineGroupModule {
}
